import { SET_NETWORK_STATUS } from "../constants";

const reducer = (state = navigator.onLine, action) => {
  switch (action.type) {
    case SET_NETWORK_STATUS:
      return action.payload;
    default:
      return state;
  }
};
export default reducer;
